import {h, render} from 'preact';

export default el => {
    const wrapper = el.querySelector('.accomodations__elementWrapper');
    const dataMoreEnabled = wrapper.getAttribute('data-more-enabled');
    if (!dataMoreEnabled) {
        return;
    }

    const elements = wrapper.querySelectorAll('.accomodations__element');
    const limit = parseInt(wrapper.getAttribute('data-more-limit'));

    let clicks = 1;
    const button = el.querySelector('.accomodations__moreButton');

    if (elements.length > limit) {
        button.classList.remove('accomodations__moreButton--hidden');
    }

    if (button) {
        button.addEventListener('click', () => {
            clicks++;

            let elementCount = 0;
            elements.forEach(element => {
                elementCount++;
                if (elementCount <= (clicks * limit)) {
                    element.classList.remove('accomodations__element--hidden');
                }
            });

            if (elements.length <= (clicks * limit)) {
                button.classList.add('accomodations__moreButton--hidden');
            }

        });
    }
};
